<div #modal
  [ngClass]="{show: isVisible}"
  class="modal"
  [@animateModal]="animationState"
  aria-hidden="true"
  backdrop="static"
  [attr.aria-labelledby]="name"
  tabindex="-1"
  role="dialog">
  @if (isVisible) {
    <div
      class="modal-dialog modal-lg"
      role="document"
      [ngStyle]="{ maxWidth: config?.maxWidth, 'disable-overflow': config?.disableYOverflow }">
      <div class="modal-content">
        @if (!config?.hideHeader) {
          <div class="modal-header d-flex align-items-center {{ config?.headerClass }}"
            >
            <div class="d-flex justify-content-between w-100">
              @if (config?.hideCancel) {
                <button
                  type="button"
                  class="rs-btn-link fw-700 fs-18 back"
                  aria-label="Close"
                  (click)="closeModal('button')">
                  Back
                </button>
              }
              <h4 class="modal-title">
                <span class="fw-700">{{ config?.title }}</span>
              </h4>
              @if (!config?.hideCancel) {
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  (click)="closeModal('button')">
                  <span aria-hidden="true">×</span>
                </button>
              }
              @if (config?.hideCancel) {
                <button
                  type="button"
                  class="rs-btn-link fw-700 fs-18 save-selection"
                  aria-label="Close"
                  (click)="onSubmit()">
                  Save selection
                </button>
              }
            </div>
          </div>
        }
        @if (config?.subtitle) {
          <div class="d-flex align-items-center">
            <span class=" modal-subtitle">
              {{ config?.subtitle }}
            </span>
          </div>
        }
        <div class="modal-body {{ config?.bodyClass }}"
          [ngClass]="{ 'pt-0': !config?.hideHeader }"
          [ngStyle]="{ maxHeight: config?.maxHeight, minHeight: config?.minHeight }">
          <ng-content></ng-content>
          <!-- <p>Modal body text goes here.</p> -->
          @if (config?.error) {
            <div
            class="text-center alert-danger icon">{{ config?.error }}</div>
          }
        </div>
        @if (!config?.footer.hidden) {
          <div class="row no-gutters modal-footer"
            >
            @if (config?.footer.close) {
              <button type="button"
                class="btn btn-inverted btn-lg btn-lg-font-sm footer-item"
                [ngClass]="{ 'col-md-12': !multipleButtons, 'multiple-btns': multipleButtons}"
              (click)="closeModal('cancel')">{{ config?.footer.close }}</button>
            }
            @if (config?.footer.delete) {
              <button type="button"
                class="btn btn-warning btn-lg btn-lg-font-sm footer-item"
                [ngClass]="{ 'col-md-12': !multipleButtons, 'multiple-btns': multipleButtons}"
              (click)="onDelete()">{{ config?.footer.delete }}</button>
            }
            @if (config?.footer.save) {
              <button
                (click)="onSubmit()"
                class="btn btn-block btn-main btn-lg-loader btn-lg-font-sm d-flex align-items-center justify-content-center position-relative footer-item"
                [ngClass]="{ 'col-md-12': !multipleButtons, 'multiple-btns': multipleButtons}"
                [disabled]="!config?.footer.saveEnabled">
                @if (config?.footer?.saveLoading) {
                  <span class="ml-3 spinner-border spinner-border-sm text-light"
                    role="status"
                  aria-hidden="true"></span>
                  <span class="sr-only">Loading...</span>
                }
                {{ config?.footer.save }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
